import { Navigate } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuth } from '@/context/AuthContext'
import { canManageHrSettings } from '@/features/hr/access'

/** Lets owners, super admins and Admins of the HR department through; everyone else goes back to Settings. */
export default function HrAdminRoute({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth()
  if (isLoading) return null
  if (!canManageHrSettings(user)) return <Navigate to="/app/settings" replace />
  return <>{children}</>
}
